import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-750e9556"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "preview-content"
}
const _hoisted_2 = { class: "label" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "textarea" }
const _hoisted_5 = { class: "enclosure" }
const _hoisted_6 = {
  key: 0,
  class: "noList"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "add" }, "+添加附件", -1))
const _hoisted_8 = {
  key: 0,
  class: "list",
  style: {"width":"100%"}
}

import { ElMessage, UploadFile, UploadFiles, UploadProps } from "element-plus";
import _ from "lodash";
import { getCurrentInstance, onMounted, reactive, ref, watch } from "vue";
import selectTemplate from "./part/select-template.vue";
import imageTemplate from "./part/image-template.vue";
import videoTemplate from "./part/video-template.vue";
import linkTemplate from "./part/link-template.vue";
import miniprogramTemplate from "./part/miniprogram-template.vue";
import { IEnclosureType } from "./interface";

interface IPreviewContent {
  labelList: string[];
  text: string;
  attachmentList: any[];
  enclosureType: IEnclosureType[];
}

const __default__ = { name: "MasPreviewContent" };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  content: {
    type: Object as () => IPreviewContent,
  },
},
  setup(__props) {

const props = __props

const { proxy } = getCurrentInstance() as any;


const imageTemplateRef = ref<any>(null);
const videoTemplateRef = ref<any>(null);
const linkTemplateRef = ref<any>(null);
const appletTemplateRef = ref<any>(null);
const state = reactive({
  contentText: "",
  blurIndex: 0,
  attachmentList: [],
});
const _inputBlur = (e: any) => {
  state.blurIndex = e.srcElement.selectionStart;
};
const _inputEvent = () => {
  proxy.$emit("update:content", state.contentText);
};
const _insertContentHandle = (text: string) => {
  let handleText = text.replace("插入", "");
  // if (state.contentText.indexOf(handleText) !== -1) {
  //   return false;
  // }
  let index = state.blurIndex;
  let str = state.contentText;
  state.contentText = str.slice(0, index) + handleText + str.slice(index);
  state.blurIndex = state.contentText.length;
  proxy.$emit("update:content", state.contentText);
};
const openTemplate = (item: IEnclosureType) => {
  openTemplateFn(item, 1);
};
// 增加文件 【这里跟弹层内进行关联】
const updateSuccess = (uploadFiles: UploadFiles, type: string) => {
  // 定义上传文件类型 type: 指定文件类型 【用于展示】 id：指定文件的唯一标识 【用于编辑】 responseId: 用于编辑和回写统一预览
  uploadFiles.forEach((x: any) => {
    x.type = type;
    x.resourceId = x.list?.length ? x.list[0].response.data.id : "";
    x.enclosureId = x.enclosureId ? x.enclosureId : x.list[0].response.data.id;
    if (state.attachmentList.length) {
      state.attachmentList.forEach((y: any) => {
        if (x.enclosureId === y.enclosureId) {
          let curInIndex = state.attachmentList.indexOf(y);
          state.attachmentList.splice(curInIndex, 1);
          state.attachmentList.push(x);
        } else {
          state.attachmentList.push(x);
        }
      });
    } else {
      state.attachmentList.push(x);
    }
  });
  state.attachmentList = _.uniqWith(state.attachmentList, _.isEqual);
  proxy.$emit("update:attachmentList", state.attachmentList);
};
// 删除文件
const onRemove = (file, uploadFiles) => {
  proxy.$emit("update:attachmentList", uploadFiles);
};
// 预览文件
const handlePreview: UploadProps["onPreview"] = (curFile: any) => {
  openTemplateFn(curFile, 2);
};

// 通用
const openTemplateFn = (curFile: any, type: number) => {
  let openRef = null;
  switch (curFile.type) {
    case "image":
      openRef = imageTemplateRef.value;
      break;
    case "video":
      openRef = videoTemplateRef.value;
      break;
    case "link":
      openRef = linkTemplateRef.value;
      break;
    case "miniprogram":
      openRef = appletTemplateRef.value;
      break;
  }
  let fileCur = {};
  if (curFile.list?.length) {
    fileCur = _.merge({}, curFile, curFile.list[0]);
  } else {
    fileCur = { ...curFile };
  }
  openRef.active(fileCur, type);
};

watch(
  () => props.content,
  (newVal: any) => {
    state.contentText = newVal.content;
    state.attachmentList = newVal.attachmentList;
  },
  {
    deep: true,
    immediate: true,
  }
);
onMounted(() => {});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (!_unref(_).isEmpty(__props.content))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.content?.labelList, (item, index) => {
            return (_openBlock(), _createElementBlock("span", {
              class: "color-2d75d4",
              key: index,
              onClick: ($event: any) => (_insertContentHandle(item))
            }, _toDisplayString(item), 9, _hoisted_3))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_input, {
            type: "textarea",
            rows: "6",
            modelValue: _unref(state).contentText,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).contentText) = $event)),
            placeholder: "请输入内容",
            maxlength: "600",
            "show-word-limit": "",
            resize: "none",
            onInput: _inputEvent,
            onBlur: _inputBlur
          }, null, 8, ["modelValue"])
        ]),
        (__props.content?.enclosureType?.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_5, [
                (_unref(state).attachmentList.length <= 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_el_popover, {
                        "popper-class": "hbb-work-fff",
                        placement: "top",
                        title: "",
                        width: "200px",
                        trigger: "click"
                      }, {
                        reference: _withCtx(() => [
                          _hoisted_7
                        ]),
                        default: _withCtx(() => [
                          _createVNode(selectTemplate, {
                            list: __props.content?.enclosureType,
                            onOpenTemplate: openTemplate
                          }, null, 8, ["list"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_unref(state).attachmentList.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_el_upload, {
                      "on-preview": handlePreview,
                      "file-list": _unref(state).attachmentList,
                      "on-remove": onRemove
                    }, null, 8, ["file-list"])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(imageTemplate, {
          ref_key: "imageTemplateRef",
          ref: imageTemplateRef,
          onUpdateSuccess: updateSuccess
        }, null, 512),
        _createVNode(videoTemplate, {
          ref_key: "videoTemplateRef",
          ref: videoTemplateRef,
          onUpdateSuccess: updateSuccess
        }, null, 512),
        _createVNode(linkTemplate, {
          ref_key: "linkTemplateRef",
          ref: linkTemplateRef,
          onUpdateSuccess: updateSuccess
        }, null, 512),
        _createVNode(miniprogramTemplate, {
          ref_key: "appletTemplateRef",
          ref: appletTemplateRef,
          onUpdateSuccess: updateSuccess
        }, null, 512)
      ]))
    : _createCommentVNode("", true)
}
}

})